// extracted by mini-css-extract-plugin
export default {"readerContainer":"Modal_2_1_readerContainer__7+XeR","reader":"Modal_2_1_reader__7N9wr","readerBg":"Modal_2_1_readerBg__UuIBD","readerBgText":"Modal_2_1_readerBgText__kRNls"};